import { render } from "./Component.vue?vue&type=template&id=495bdb44&scoped=true"
import script from "./Component.vue?vue&type=script&lang=js"
export * from "./Component.vue?vue&type=script&lang=js"

import "./Component.vue?vue&type=style&index=0&id=495bdb44&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-495bdb44"]])

export default __exports__